import { Owner, USERS_LIST_FOR_POPOVER, User } from 'cargo-chief-commons';
import { ACCOUNT_STATUS } from '@domain/constants/app-variables';

// Assignable reps. ACTIVE only — PENDING users have never activated their account and
// INACTIVE users are deactivated, so neither may be offered as an owner.
export const ACTIVE_USERS = (users: User[], assigneeId: number = null): Owner[] =>
	USERS_LIST_FOR_POPOVER({
		users,
		assigneeId,
		keepHavingStatus: [ACCOUNT_STATUS.ACTIVE],
	});

// Every account user regardless of status. Use for resolving the display label of an
// existing assignment and for building sort keys — never for dropdown options.
export const ALL_ACCOUNT_USERS = (users: User[], assigneeId: number = null): Owner[] =>
	USERS_LIST_FOR_POPOVER({
		users,
		assigneeId,
		keepHavingStatus: 'ALL',
	});
